export default __webpack_public_path__ + "static/media/delete.334c461b.svg";